import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useContext } from 'react';
import { Col, Row, EVEntry } from '@uswitch/ev-core/react';
import ModuleWrapper, { ModuleWrapperContext } from '../../helpers/module-wrapper';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export default (function (_ref) {
  var _ref$entries = _ref.entries,
      entries = _ref$entries === void 0 ? [] : _ref$entries,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  var wrapperContext = useContext(ModuleWrapperContext);
  var defaultSpacing = wrapperContext.alreadyWrapped ? 0 : 'lg';
  var _options$spacingTop = options.spacingTop,
      spacingTop = _options$spacingTop === void 0 ? defaultSpacing : _options$spacingTop,
      _options$spacingBotto = options.spacingBottom,
      spacingBottom = _options$spacingBotto === void 0 ? defaultSpacing : _options$spacingBotto;
  var rowSx = {
    variant: 'modules.footerCollection.row'
  };
  var colSx = {
    variant: 'modules.footerCollection.column'
  };
  return _jsx(ModuleWrapper, {
    spacingTop: spacingTop,
    spacingBottom: spacingBottom,
    children: _jsx(Row, {
      direction: "row",
      wrap: true,
      sx: rowSx,
      children: entries.map(function (entry, key) {
        return key === 0 ? _jsx(Col, {
          span: [12, 6],
          sx: colSx,
          children: _jsx(EVEntry, _objectSpread({}, entry))
        }, key) : _jsx(Col, {
          span: [6, 2],
          sx: colSx,
          children: _jsx(EVEntry, _objectSpread({}, entry))
        }, key);
      }, this)
    })
  });
});
//# sourceMappingURL=collection-footer.js.map